import { Component, OnInit, Inject,OnDestroy,ViewEncapsulation } from '@angular/core';
import { Validators, FormGroup, FormControl } from '@angular/forms';
import { Subscription, Subject } from 'rxjs';
import { MediaChange, MediaObserver } from '@angular/flex-layout';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog} from '@angular/material';
import { ResidentForCreationResponse, getAlertByTagId} from '../resident';
import { ResidentService } from '../resident.service';
import { ReleAuthorize, ReleaseResident, Residentreleasetype } from '../resident';
import {appsettings} from '../../../app-settings';
import { ApiService } from '../../../api.service';
import { TagIdfoundResponse,GetAlertsId, checkTagId, checkMapLocation } from '../../../api';
import { Http } from '@angular/http';
import { RollbarService } from '../../../rollbar';
import * as Rollbar from 'rollbar';
import { SessionCheck, generateAlertMessage,AuthFailedMessage } from '../../../app-general';
import { AlertMessageComponent } from '../../../alert-message/alert-message.component';
import {Router} from '@angular/router';
import { takeUntil } from 'rxjs/operators';
@Component({
  selector: 'app-release-resident',
  templateUrl: './release-resident.component.html',
  providers: [ ResidentService ],
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./release-resident.component.scss']
})
export class ReleaseResidentComponent implements OnInit,OnDestroy {

  watcher: Subscription;
  columns: number = 3;
  public residentreleaseForm : FormGroup;
  public residentreallocateForm : FormGroup;
  private URL = appsettings.URLinfo+'getAuthorizer';
  public ReleAuthorized : ReleAuthorize[];
  currentDate;
  selectedvalue;
  Release: number = Residentreleasetype.Release;
  Reallocate: number = Residentreleasetype.Reallocate;
  selectDisabled;
  residentTagId;
  residentname;
  cancelstatus;
  authorizedName;
  SiteId = "1";
  private _onDestroy: Subject<void> = new Subject<void>();
  ReleType;
  constructor(private router: Router,mediaObserver: MediaObserver,private residentService: ResidentService,public dialog: MatDialog,
    @Inject(RollbarService) private rollbar: Rollbar,public thisDialogRef: MatDialogRef<ReleaseResidentComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
              private http:Http,private apiService: ApiService,) {
                this.ReleType = data.Reltype;
                
    this.watcher = mediaObserver.media$.subscribe((change: MediaChange) => {
      if (change) {       
        if (change.mqAlias == 'xs') {
          this.columns = 2;
        } 
        else if (change.mqAlias == 'sm') {
          this.columns = 3;
        }  
        else
        {
          this.columns = 3;
        }    
      }
    });            
    this.residentTagId = data.ResidentbyId[0].TagId;
    this.residentname = data.ResidentbyId[0].FirstName + " " + data.ResidentbyId[0].LastName;
  }   
  
  ngOnInit() {

      this.getAuthorizedList();      
      this.currentDate = new Date().toJSON("yyyy/MM/dd");
      this.residentreleaseForm = new FormGroup({
      residentname: new FormControl('', [Validators.required, Validators.maxLength(60), Validators.pattern(appsettings.Name_Pattern)]),
      residentId: new FormControl(''),
      date : new FormControl(''),
      residentstatus : new FormControl('', [Validators.required]),
      reason : new FormControl('', [Validators.required, Validators.pattern(appsettings.Name_Pattern)]),
      authorizedby : new FormControl('', [Validators.required]),
        });

      this.residentreleaseForm.get('residentname').disable();
      this.residentreleaseForm.get('date').disable();
      this.residentreleaseForm.get('authorizedby').disable();
      this.selectedvalue="1";
      this.residentreallocateForm = new FormGroup({
        reallocatestatus : new FormControl('', [Validators.required]),
        residentId : new FormControl(''),        
        tagid: new FormControl('', [Validators.required, Validators.maxLength(10),Validators.max(1073741823),Validators.min(1), Validators.pattern(appsettings.Number_Pattern)]),
      });

  }
  
  handleInput(event) 
  {
    try
    {
      var n = event.target.value.lastIndexOf(" ");
      var l = event.target.value.length;
      var changedValue = event.target.value;
      if (event.which == 32 && changedValue.trim().length == 0) {
        changedValue = changedValue.trim();
      }
      else if (event.which == 32) {
        if (n + 1 == l) {
          changedValue = changedValue.trim() + " ";
        }
        else {
          changedValue = changedValue.trim();
        }
      }
      Object.keys(this.residentreleaseForm.controls).forEach(field => { // {1}
        const control = this.residentreleaseForm.get(field); // {2}
        if (field == document.getElementById(event.target.id).getAttribute("formControlName")) {
          control.setValue(changedValue);
          control.markAsTouched({ onlySelf: true });       // {3}
        }
      });
    }
    catch(err) 
    {
      throw new Error('add-staff.component.ts' + ' - handleInput() - ' + err.message);
    }
  }

  public onCloseCancel = () => {
   
    this.thisDialogRef.close('Cancel');
    if(!SessionCheck(this.router))
    {
        return;
    }
  }

  getAuthorizedList()
  {    
    try
    {      
      this.authorizedName = JSON.parse(localStorage.getItem("username"));      
    }
    catch (err) {
      throw new Error('release-resident.component.ts' + ' - getAuthorizedList() - ' + err.message);
    }
  } 
  
  public releaseResidentbyId = (releaseFormValue) => {
    if(!SessionCheck(this.router))
    {
        this.thisDialogRef.close('Cancel');
        return;
    }
    let saveclick = document.getElementById('btnresidentrelease');
        saveclick.className = 'clsbtnResRelease mat-raised-button disablebtn';
    (document.activeElement as HTMLTextAreaElement).blur();
    if (this.residentreleaseForm.valid) {             
       this.getAlertsByTagId(releaseFormValue,this.Release);
    }
    else{
      saveclick.className = 'clsbtnResRelease mat-raised-button';
    }
  }

  public reallocateResidentbyId = (reallocateFormValue) => {
    if(!SessionCheck(this.router))
    {
        this.thisDialogRef.close('Cancel');
        return;
    }
    let saveclick = document.getElementById('btnresidentsave');
        saveclick.className = 'clsbtnResRelease mat-raised-button disablebtn';
    (document.activeElement as HTMLTextAreaElement).blur();
    if (this.residentreallocateForm.valid) {   
       this.getAlertsByTagId(reallocateFormValue,this.Reallocate);
    }
    else{
      saveclick.className = 'clsbtnResRelease mat-raised-button';
    }
  }
  
  private getAlertsByTagId = (releaseFormValue,type) => {
    
    try
    {      
      if(type == this.Release)
      {            
            var restagid : getAlertByTagId = 
            {
              siteId:this.SiteId,
              authKey: localStorage.getItem("Authkey"),
              tagId: parseInt(this.residentTagId)
            } 
              this.residentService.getAlertsByTagId(restagid).pipe(takeUntil(this._onDestroy))
            .subscribe((alertdata : GetAlertsId[])=>
            {
                        
              if(alertdata != null && alertdata.length == 0)
              {
                  this.releaseResident(releaseFormValue)
              }
              else
              {
                  generateAlertMessage(this.dialog, "This resident " + this.residentname + " has open alerts, please complete or cancel those alerts and try again.")
                  this.thisDialogRef.close('Close');                
              }
            });        
      }
      else if(type == this.Reallocate)
      {
        var tagidfoundItem : checkTagId = 
        {
          siteId:this.SiteId, 
          authKey: localStorage.getItem("Authkey"),
          newTagId: parseInt(releaseFormValue.tagid), 
          resStaffId: parseInt(releaseFormValue.residentId) 
        }      
        this.apiService.checkTagId(tagidfoundItem).pipe(takeUntil(this._onDestroy))
        .subscribe((apiresponse : TagIdfoundResponse[])=>{                
          if(apiresponse.toString() == "not found")
          {
            this.checkMapLocation(releaseFormValue)           
          }
          else
          {                     
            generateAlertMessage(this.dialog,"Duplicate tagid found, the "+apiresponse[0].desc+"  '"+ apiresponse[0].name+"'  already has this tagid.<br> Please try again with different tagid"); 
            if(this.ReleType == 2)
            {
              let saveclick = document.getElementById('btnresidentsave');
                  saveclick.className = 'clsbtnResRelease mat-raised-button';
            }
            return;
          }

        });

      }           
    }
    catch (err) {
      throw new Error('release-resident.component.ts' + ' - getAlertsByTagId() - ' + err.message);
    }

  }

  checkMapLocation(releaseFormValue)
  {
    try
    {
      var campusfoundItem : checkMapLocation = 
      {
        siteId:this.SiteId, 
        authKey: localStorage.getItem("Authkey"),
        resStaffId: parseInt(releaseFormValue.residentId)
      }
      this.apiService.checkMapLocation(campusfoundItem).pipe(takeUntil(this._onDestroy))
      .subscribe((apiresponse : TagIdfoundResponse[])=>{        
        if(apiresponse.toString() == "found")
        {             
          this.onReallocateClicked(releaseFormValue);
        }
        else 
        {   
          if(this.ReleType == 2)
          {
            let saveclick = document.getElementById('btnresidentsave');
              saveclick.className = 'clsbtnResRelease mat-raised-button';
          }              
          var AlertMessageData = {
            AlertMessage: "This resident " + this.residentname + " is not having " + apiresponse.toString() + " details, <br> Campus should be defined to send Geo Pendant Alerts to staffs.<br> Please fill-in Campus details for this resident."          
          }
          var br_count = AlertMessageData.AlertMessage.split('<br>');
          var _height;
          if (br_count.length > 1) {
            _height = (br_count.length - 1) * 18;
            _height = parseInt(180 + (_height)) + 'px';
          }
          else {
            _height = '180px';
          }
          let dialogRef = this.dialog.open(AlertMessageComponent, {
            disableClose: true,
            width: 'auto',
            height: _height,
            panelClass: 'myapp-no-padding-dialog',
            autoFocus: false,
            data: AlertMessageData
          });
        
          dialogRef.afterClosed().subscribe(result => { 
            this.onReallocateClicked(releaseFormValue);
          });     
        
        }     
      });
    }
    catch (err) {
      throw new Error('release-resident.component.ts' + ' - checkMapLocation() - ' + err.message);
    }
  }
  releaseResident(releaseFormValue)
  {
    if(this.ReleType == 2)
    {
      let saveclick = document.getElementById('btnresidentsave');
          saveclick.className = 'clsbtnResRelease mat-raised-button';
    }
    let releaseResident: ReleaseResident = {
      siteId: this.SiteId, 
      authKey: localStorage.getItem("Authkey"),
      residentId : parseInt(releaseFormValue.residentId),
      status : parseInt(releaseFormValue.residentstatus),
      reason : releaseFormValue.reason.replace(/\s+/g, ' ').trim(),
      authorizedBy : this.authorizedName.toString(), 
      tagId : 0                  
    }       
        this.residentService.releaseResident(releaseResident).pipe(takeUntil(this._onDestroy))
        .subscribe((apiresponse : ResidentForCreationResponse[])=>{            
        if(apiresponse["apiReturn"] == "Success")
        { 	            
          this.apiService.reloadactivetag();  
          generateAlertMessage(this.dialog, 'Resident data released successfully.')                        
        }   
        else if(apiresponse["apiReturn"] == "Fail") 
        {         
          generateAlertMessage(this.dialog, 'Resident data released failed.')           
        }
        else if(apiresponse["apiReturn"] == "Invalid Auth Key")
        {                  
          this.thisDialogRef.close('Confirm');   
          AuthFailedMessage(this.dialog,this.router);  
          return;       
        }   
        this.thisDialogRef.close('Confirm');        
      });
  }

  onReallocateClicked(releaseResidentdata)
  {     
    try
    {
        let resReason = "";
        let resAuthorizedName = "";
        
        if(this.ReleType == 1)
        {
          resReason = releaseResidentdata.reason.replace(/\s+/g, ' ').trim();
          resAuthorizedName = this.authorizedName.toString(); 
        }
        else if(this.ReleType == 2)
        {
          resReason = "";
          resAuthorizedName = "";
          
          let saveclick = document.getElementById('btnresidentsave');
              saveclick.className = 'clsbtnResRelease mat-raised-button';
        }
        let releaseResident: ReleaseResident = 
        {
          siteId: this.SiteId, 
          authKey: localStorage.getItem("Authkey"),
          residentId : parseInt(releaseResidentdata.residentId),
          status : parseInt(releaseResidentdata.reallocatestatus),
          reason : resReason,
          authorizedBy : resAuthorizedName,
          tagId : parseInt(releaseResidentdata.tagid)
        }          
          this.residentService.releaseResident(releaseResident).pipe(takeUntil(this._onDestroy))
          .subscribe((apiresponse : ResidentForCreationResponse[])=>{           
          
          if(apiresponse.toString() == "true")
          { 	 
            this.apiService.reloadactivetag();
            generateAlertMessage(this.dialog, 'Resident data reallocated successfully.')                                
          }     
          else if(apiresponse.toString() == "false")
          { 	                             
            generateAlertMessage(this.dialog, 'Resident data reallocated failed.')
          }  
          else if(apiresponse["condition"] == "Authfalse")
          {                  
            this.thisDialogRef.close('Confirm');   
            AuthFailedMessage(this.dialog,this.router);  
            return;       
          }   
          this.thisDialogRef.close('Confirm');        
        });
    }
    catch (err) {
      throw new Error('release-resident.component.ts' + ' - onReallocateClicked() - ' + err.message);
    }  

  }
  
   ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }
}
